import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

import { authGuard } from '@/auth/authGuard'

// Layouts
import Layout1 from '@/layout/Layout1'
import LayoutBlank from '@/layout/LayoutBlank'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    component: Layout1,
    children: [{
      beforeEnter: authGuard,
      path: '',
      component: () => import('@/components/TenantsList')
    }, {
      beforeEnter: authGuard,
      path: 'tenants',
      component: () => import('@/components/TenantsList')
    }, {
      beforeEnter: authGuard,
      path: 'tenants/create',
      component: () => import('@/components/TenantsCreate')
    }, {
      beforeEnter: authGuard,
      path: 'tenants/edit/:tenantId',
      component: () => import('@/components/TenantsEdit')
    }, {
      beforeEnter: authGuard,
      path: 'feeds',
      component: () => import('@/components/FeedsList')
    }, {
      beforeEnter: authGuard,
      path: 'feeds/create',
      component: () => import('@/components/FeedsCreate')
    }, {
      beforeEnter: authGuard,
      path: 'feeds/edit/:feedId',
      component: () => import('@/components/FeedsEdit')
    }, {
      beforeEnter: authGuard,
      path: 'audit-trail/:appName',
      component: () => import('@/components/AuditTrail')
    }, {
      beforeEnter: authGuard,
      path: 'deployments',
      component: () => import('@/components/DeploymentsList')
    }]
  }, {
    path: '/',
    component: LayoutBlank,
    children: [{
      path: 'authorization-failed',
      component: () => import('@/components/AuthorizationFailed')
    }]
  }, {
    // 404 Not Found page
    path: '*',
    component: NotFound
  }]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Clear remembered feeds filters when leaving the feeds section
  try {
    const target = to && to.path ? to.path : ''
    if (!target.startsWith('/feeds')) {
      sessionStorage.removeItem('feeds_status_filter')
      sessionStorage.removeItem('feeds_search_query')
      sessionStorage.removeItem('feeds_list_page')
    }
  } catch (e) {
    // ignore storage errors
  }

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
